import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CardBenefitsComponent } from './card-benefits.component';
import { IconModule } from '../icon/icon.module';
import { BadgeModule } from '../badge/badge.module';
import { TextModule } from '../text/text.module';
import { TitleModule } from '../title/title.module';
import { StackModule } from '../stack/stack.module';
import { BoxModule } from '../box/box.module';
import { BrandModule } from '../brand/brand.module'
@NgModule({
  declarations: [CardBenefitsComponent],
  imports: [CommonModule, IconModule, BadgeModule, TextModule, TitleModule, StackModule, BoxModule, BrandModule],
  exports: [CardBenefitsComponent],
})
export class CardBenefitsModule {}
